@let borough = parserBorough();

<homey-page-title-layout>
  Affordable Housing Lottery Apartments{{ postFix() }}
</homey-page-title-layout>
<p class="mb-8">
  {{ listDescription() }}
</p>

<div class="sr-only">
  <a routerLink="/apartments/boroughs/manhattan">
    Manhattan apartments
  </a>
  <a routerLink="/apartments/boroughs/bronx">
    Bronx apartments
  </a>
  <a routerLink="/apartments/boroughs/brooklyn">
    Brooklyn apartments
  </a>
  <a routerLink="/apartments/boroughs/queens">
    Queens apartments
  </a>
  <a routerLink="/apartments/boroughs/staten-island">
    Staten Island apartments
  </a>
</div>

<p-selectButton
  id="household-size"
  [unselectable]="false"
  [allowEmpty]="false"
  [ngModel]="borough"
  (ngModelChange)="onBoroughChange($event)"
  [styleClass]="'flex-auto h-12 custom-toggle-button'"
  [options]="boroughOptions"
  optionLabel="label" optionValue="value"/>

<homey-lottery-list
  class="mt-6"
  ngSkipHydration
  [emptyState]="{
    title: emptyTitle(),
    description: 'We\u2019re sorry, check in later'
  }"
  [lotteries]="openLotteries()"
>
  <ng-template [lotteryListItem]="openLotteries()" let-lottery>
    <homey-lottery-list-item [apartment]="lottery"
                             [baseRoute]="baseRoute()"
                             [showNeighbourhoodAndBorough]="false">
      <div>
        <p class="text-muted-color">{{ lottery | apartmentAddress }}</p>
        <p class="text-muted-color">
          Closes {{ lottery.endDate | date }}
        </p>
      </div>
    </homey-lottery-list-item>
  </ng-template>
</homey-lottery-list>

<div class="mt-8">
  <p-divider [dt]="whiteDividerDt">
    <span class="text-muted-color">Closed lotteries</span></p-divider>
</div>
<homey-lottery-list class="mt-8" ngSkipHydration
                    [lotteries]="closedLotteries()">
  <ng-template [lotteryListItem]="closedLotteries()" let-lottery>
    <homey-lottery-list-item class="opacity-70"
                             [baseRoute]="baseRoute()"
                             [apartment]="lottery"
                             [showNeighbourhoodAndBorough]="false">
      <div>
        <p class="text-muted-color">{{ lottery | apartmentAddress }}</p>
        <p class="text-muted-color">
          Closed since {{ lottery.endDate | date }}
        </p>
      </div>
    </homey-lottery-list-item>
  </ng-template>
</homey-lottery-list>

<homey-lotteries-and-footer/>
